import { Collapse as MantineCollapse } from '@mantine/core';
import { forwardRef } from 'react';
import { useReducedMotion } from '../hooks';

export interface CollapseHeightProps {
  children: React.ReactNode;
  visible?: boolean;
  duration?: number;
  timingFunction?: string;
  onTransitionEnd?: () => void;
}

const CollapseHeight = forwardRef<HTMLDivElement, CollapseHeightProps>(
  (
    {
      children,
      visible = true,
      duration = 200,
      timingFunction = 'ease',
      onTransitionEnd,
    },
    ref
  ) => {
    const reducedMotion = useReducedMotion();
    const actualDuration = reducedMotion ? 0 : duration;

    return (
      <MantineCollapse
        in={visible}
        transitionDuration={actualDuration}
        transitionTimingFunction={timingFunction}
        onTransitionEnd={onTransitionEnd}
      >
        <div ref={ref}>{children}</div>
      </MantineCollapse>
    );
  }
);

CollapseHeight.displayName = 'CollapseHeight';

export default CollapseHeight;
